import Beef from 'assets/images/beef.95b6ea9e.svg';
import Chicken from 'assets/images/chicken.0bf00278.svg';
import Coffee from 'assets/images/coffee.06d317df.svg';
import Dinner from 'assets/images/dinner.5e12f363.svg';
import Burger from 'assets/images/burgerBreakfast.svg';
import Juice from 'assets/images/juice.dd087137.svg';
import Lunch from 'assets/images/lunch.68d27597.svg';
import Pork from 'assets/images/pork.98f99006.svg';
import Tea from 'assets/images/tea.591a2362.svg';

const homeCategoryData = [
	{
		img: Burger,
		name: 'breakfast',
	},
	{
		img: Coffee,
		name: 'coffee',
	},
	{
		img: Pork,
		name: 'pork ham',
	},
	{
		img: Dinner,
		name: 'dinner',
	},
	{
		img: Tea,
		name: 'tea',
	},
	{
		img: Lunch,
		name: 'lunch',
	},
	{
		img: Juice,
		name: 'juice',
	},
	{
		img: Chicken,
		name: 'grilled chicken',
	},
	{
		img: Beef,
		name: 'roast beef',
	},
];

export { homeCategoryData };
